import { Map } from 'immutable';

import { REQUEST_ADDRESS_REQUEST, REQUEST_ADDRESS_FAILURE, REQUEST_ADDRESS_SUCCESS } from './action';

const initialState = Map({
  type: '',
  payload: [],
});

function reducer(state = initialState, action) {
  const { type } = action;

  if (type === REQUEST_ADDRESS_REQUEST) {
    return state
      .updateIn(['type'], () => type)
      .updateIn(['isLoading'], () => true)
      .updateIn(['isLoaded'], () => false)
      .setIn(['payload'], []);
  }

  if (type === REQUEST_ADDRESS_FAILURE) {
    const { payload } = action;
    return state
      .updateIn(['type'], () => type)
      .updateIn(['isLoading'], () => false)
      .updateIn(['isLoaded'], () => false)
      .setIn(['payload'], payload);
  }

  if (type === REQUEST_ADDRESS_SUCCESS) {
    const { payload } = action;
    return state
      .updateIn(['type'], () => type)
      .updateIn(['isLoading'], () => false)
      .updateIn(['isLoaded'], () => true)
      .setIn(['payload'], payload);
  }

  return state;
}

export default reducer;
